import {
  ViewEncapsulation,
  OnInit,
  ViewChild,
  Component,
  ElementRef
} from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { SupportService } from 'src/app/services/support.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import {
  CreateUser,
  VendorSelectedValue,
  VendorFetchFilter,
  VendorDataList,
  filters,
  filters_name,
  DownloadCsvData,
  consent_update
} from 'src/app/models/supportcreateuser';
import { HttpErrorResponse } from '@angular/common/http';
import {
  DateUtilService,
  date_format
} from 'src/app/utilities/date.util.service';
import { ROLES } from 'src/app/constant/constant';
import { TokenService } from '../../../../utilities/token.service';
import { DaterenderService } from 'src/app/services/daterender.service';
import { PatientService } from 'src/app/services/patient.service';
import {
  ApiResult,
  PromiseResult,
  ServerError
} from 'src/app/models/PromiseResult';
import { reportspdf } from 'src/app/models/reportspdf';
import { DoctorsService } from 'src/app/services/doctors.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
  selector: 'app-fetch-user-list',
  templateUrl: './fetch-user-list.component.html',
  styleUrls: ['./fetch-user-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FetchUserListComponent implements OnInit {
  @ViewChild('htmlData') htmlData: ElementRef;

  createUser1: CreateUser = new CreateUser();

  dropdownOptions: { label: string; value: filters }[] = [
    { label: filters_name[filters.None], value: null },
    {
      label: filters_name[filters.booking_id_no],
      value: filters.booking_id_no
    },
    { label: filters_name[filters.policy_no], value: filters.policy_no },
    {
      label: filters_name[filters.primary_contact_number],
      value: filters.primary_contact_number
    },
    { label: filters_name[filters.first_name], value: filters.first_name },
    { label: filters_name[filters.last_name], value: filters.last_name }
  ];

  doctorReportsApiResult: ApiResult = new ApiResult();
  response: PromiseResult;
  serverError: ServerError;
  displayModel1: boolean = false;
  displayModel: boolean = false;
  doctorReportsData: reportspdf;
  prescriptionApiResult: ApiResult = new ApiResult();
  prescriptionData: reportspdf;
  consent_update: consent_update = new consent_update();
  showPrescription: string = 'showPrescription';
  showDoctorReports: string = 'showDoctorReports';
  printContent: string = 'print-content';
  showPrescriptiond: string = 'showPrescription';
  showDoctorReportsd: string = 'showDoctorReports';
  member = '';
  slug: string = "";
  update_msg: string;
  posting: boolean;
  display: boolean = false;
  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly supportservice: SupportService,
    private readonly dateUtil: DateUtilService,
    private readonly tokenUtil: TokenService,
    private readonly daterenderService: DaterenderService,
    private readonly patientservice: PatientService,
    private readonly doctorsService: DoctorsService,
    private readonly providerstateService: ProviderStateService
  ) {
    this.createUser1.other_user_list.roles = ROLES;
  }

  private async ResetResponseModel(): Promise<void> {
    this.createUser1.create_api_result.PromiseResult = {
      success: null,
      error: null,
      data: null
    };
    this.createUser1.create_api_result.ServerError = {
      statusCode: null,
      error: null,
      message: null
    };
  }

  async InitFilter(call_api: boolean) {
    this.createUser1.other_user_list.disabledDates = true;
    this.createUser1.other_user_list.invalid_date_message = false;
    this.createUser1.other_user_list.query = {
      to_date: null,
      from_date: null,
      page_no: 1,
      records_per_page: 10,
      status: null,
      first: 0,
      filter_key: null,
      filter_value: null,
      vendor_guid: null
    };
    if (call_api) await this.getVendorPatientList(null);
  }
  async ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
    this.response = {
      success: null,
      error: null,
      data: null
    };

    this.createUser1.create_api_result.PromiseResult = {
      success: null,
      error: null,
      data: null
    };
    this.createUser1.create_api_result.ServerError = {
      statusCode: null,
      error: null,
      message: null
    };
    this.createUser1.create_api_result.Posting = false;
    this.createUser1.loading = false;
    await this.InitFilter(false);
    this.titleService.setTitle('Dashboard - User List');
    await this.getstatus();
    await this.getVendorList();
    this.createUser1.other_user_list.medical_profession_role =
      this.tokenUtil.findRoleId();
    if (
      this.createUser1.other_user_list.medical_profession_role == ROLES.Support
    )
      this.createUser1.other_user_list.is_support_role = true;
  }

  private async ResetResultModels(): Promise<void> {
    this.response = {
      success: null,
      error: null,
      data: null
    };
    this.serverError = {
      statusCode: null,
      error: null,
      message: null
    };
  }

  async getstatus() {
    await this.supportservice
      .fetchStatusList()
      .toPromise()
      .then((result) => {
        let status_data: SelectItem[] = [];
        status_data = this.getSelectItemList(result.data, '', '', true);
        status_data[0].label = 'All';
        this.createUser1.other_user_list.status = status_data;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async getVendorList(): Promise<void> {
    await this.supportservice
      .fetchVendorList()
      .toPromise()
      .then((vendor_list) => {
        vendor_list.data.forEach((ele, index) => {
          let data: VendorSelectedValue = {
            vendor_guid: ele.vendor_guid,
            country_id: ele.country_id,
            vendor_name: ele.vendor_name
          };
          ele['final_value'] = data.vendor_guid;
        });
        this.createUser1.other_data.vendor_list =
          this.utilitiesService.getSelectItemList(
            vendor_list.data,
            'vendor_name',
            'final_value'
          );
        this.createUser1.other_data.vendor_list.unshift({
          label: 'All',
          value: null
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  getSelectItemList(
    data: any,
    label: string,
    value: string,
    want_null: boolean
  ): SelectItem[] {
    return this.utilitiesService.getSelectItemList(
      data,
      label,
      value,
      want_null
    );
  }

  setQueryData() {
    if (
      this.createUser1.other_user_list.invalid_date_message &&
      ((this.createUser1.other_user_list.query.from_date != null &&
        this.createUser1.other_user_list.query.to_date != null) ||
        this.createUser1.other_user_list.disabledDates)
    ) {
      this.createUser1.other_user_list.invalid_date_message = false;
    }

    if (
      !this.createUser1.other_user_list.disabledDates &&
      (this.createUser1.other_user_list.query.from_date == null ||
        this.createUser1.other_user_list.query.to_date == null)
    ) {
      this.createUser1.other_user_list.invalid_date_message = true;
    }

    if (
      this.createUser1.other_user_list.query.filter_key == null ||
      this.createUser1.other_user_list.query.filter_value == null
    ) {
      this.createUser1.other_user_list.query.filter_key = null;
      this.createUser1.other_user_list.query.filter_value = null;
    }
  }

  createuser() {
    this.router.navigate(['/' + this.slug + '/support/create-user']);
  }

  async getVendorPatientList(event: LazyLoadEvent) {
    await this.ResetResponseModel();
    await this.setQueryData();

    this.createUser1.create_api_result.Posting = true;
    this.createUser1.loading = true;
    if (event != null) {
      this.createUser1.other_user_list.query.page_no =
        event.first / event.rows + 1;
      this.createUser1.other_user_list.query.records_per_page = event.rows;
    } else {
      this.createUser1.other_user_list.query.page_no = 1;
      this.createUser1.other_user_list.query.first = 0;
    }
    this.createUser1.other_user_list.VendorDataList = [];
    this.createUser1.other_user_list.ErrorMessage = null;
    await this.supportservice
      .GetVendorPatients(this.createUser1.other_user_list.query)
      .toPromise()
      .then((result) => {
        this.createUser1.create_api_result.PromiseResult = result;
        if (this.createUser1.create_api_result.PromiseResult.success) {
          this.createUser1.other_user_list.total_records = result.data.count;
          const rec = result.data.rows;
          let temp: VendorDataList[] = [];
          for (let i = 0; i < rec.length; i++) {
            let list_obj: VendorDataList = {
              sr_no:
                i +
                1 +
                (this.createUser1.other_user_list.query.page_no - 1) *
                this.createUser1.other_user_list.query.records_per_page,
              req_id: rec[i].req_id,
              vendor_guid: rec[i].vendor_guid,
              name:
                rec[i].first_name +
                ' ' +
                (rec[i].middle_name == null ? '' : rec[i].middle_name) +
                ' ' +
                rec[i].last_name,
              first_name: rec[i].first_name,
              middle_name: rec[i].middle_name == null ? '' : rec[i].middle_name,
              last_name: rec[i].last_name,
              primary_contact_number: rec[i].primary_contact_number,
              country_id: rec[i].country_id,
              state_id: rec[i].state_id,
              address: rec[i].address || 'N/A',
              policy_no: rec[i].policy_no,
              expiry_date: rec[i].expiry_date,
              booking_id_no: rec[i].booking_id_no,
              vendor_name: rec[i].egd_vendors.vendor_name,
              date_of_birth: rec[i].date_of_birth,
              gender: rec[i].gender,
              has_consented: rec[i].has_consented,
              e_email: rec[i].e_email || 'N/A',
              status: rec[i].status,
              doctor_assigned:
                rec[i].p_consultation != null &&
                  rec[i].p_consultation.p_consultation_appointment.length > 0 &&
                  rec[i].p_consultation.p_consultation_appointment[0].user_guid !=
                  null
                  ? rec[i].p_consultation.p_consultation_appointment
                    .map((d) => {
                      return (
                        ' ' +
                        d.egd_users.first_name +
                        ' ' +
                        d.egd_users.last_name || ''
                      );
                    })
                    .join(',')
                  : 'N/A',
              error_msg: rec[i].error_msg || 'N/A',
              consultation_request_number:
                rec[i].p_consultation == null
                  ? 'N/A'
                  : rec[i].p_consultation.consultation_request_number,
              patient_user_guid: rec[i].patient_user_guid,
              patient_guid: rec[i].patient_guid,
              package_id: rec[i].package_id,
              user_package_id: rec[i].consultationType[0].user_package_id,
              consultation_id: rec[i].consultation_id,
              updated_by_user_guid: rec[i].updated_by_user_guid,
              created_at: this.dateUtil.dateFormat(
                rec[i].created_at,
                date_format.medium
              ),
              updated_at: rec[i].updated_at,
              consultation_type_id:
                rec[i].consultationType[0].consultation_type_id,
              consultation_type_name:
                rec[i].consultationType[0].consultation_type.consultation_name,
              slots_assigned:
                rec[i].p_consultation == null
                  ? 'N/A'
                  : rec[i].p_consultation.slot_doctor_choose
                    ? 'No'
                    : this.dateUtil.getSlotTime(
                      rec[i].p_consultation.preferred_slot.slot_time
                    ),
              condition_description:
                rec[i].p_consultation == null
                  ? 'N/A'
                  : rec[i].p_consultation.condition_description,
              consultation_created_at:
                rec[i].p_consultation == null ||
                  rec[i].p_consultation.created_at == null
                  ? 'N/A'
                  : this.dateUtil.dateFormat(
                    rec[i].p_consultation.created_at,
                    date_format.medium
                  ),
              consultation_date:
                rec[i].p_consultation == null ||
                  rec[i].p_consultation.consultation_date == null
                  ? 'N/A'
                  : this.dateUtil.dateFormat(
                    rec[i].p_consultation.consultation_date,
                    date_format.medium
                  ),
              consultation_closed_date:
                rec[i].p_consultation == null ||
                  rec[i].p_consultation.consultation_closed_date == null
                  ? 'N/A'
                  : this.dateUtil.dateFormat(
                    rec[i].p_consultation.consultation_closed_date,
                    date_format.medium
                  )
            };
            temp.push(list_obj);

          }
          this.createUser1.other_user_list.VendorDataList = temp;
        } else if (!this.createUser1.create_api_result.PromiseResult.success) {
          this.createUser1.other_user_list.ErrorMessage = result.error.message;
        }
        this.createUser1.create_api_result.Posting = false;
        this.createUser1.loading = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.createUser1.create_api_result.ServerError = error.error;
        this.createUser1.create_api_result.PromiseResult.success = false;
        this.createUser1.create_api_result.Posting = false;
        this.createUser1.loading = false;
      });
  }

  async getDownloadData() {
    await this.setQueryData();
    this.createUser1.other_user_list.download_data = {
      ...this.createUser1.other_user_list.query
    };
    await this.supportservice
      .downloadCsv(this.createUser1.other_user_list.download_data)
      .toPromise()
      .then((response) => {
        let fileName = 'eGlobalDoctors-Consultations-Report.csv';
        let blob: Blob = response.body as Blob;
        let a = document.createElement('a');
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  bookappointment(user: any) {
    this.router.navigate(['/' + this.slug +
      '/support/create-consultation',
    {
      patientGuid: user.patient_guid,
      reqId: user.req_id,
      consultation_type_id: user.consultation_type_id,
      user_package_id: user.user_package_id
    }
    ]);
  }

  viewprofile() {
    this.router.navigate(['/' + this.slug + '/support/view-details']);
  }

  async gotoReportpdf(consultation_id: number, patientGuid: string) {
    this.member = patientGuid;
    await this.GetDoctorReportsData(consultation_id, patientGuid);
    this.displayModel1 = true;
  }

  async gotoprescription(consultation_id: number, patientGuid: string) {
    this.member = patientGuid;
    await this.GetPrescriptionData(consultation_id, patientGuid);
    this.displayModel = true;
  }

  private async GetPrescriptionData(
    consultation_id: number,
    patientGuid: string
  ) {
    await this.doctorsService
      .GetDoctorReportspdf(patientGuid, consultation_id, 'prescription')
      .toPromise()
      .then((result) => {
        this.prescriptionApiResult.PromiseResult = result;
        if (result.success) {
          this.response = result;
          this.prescriptionData = result.data;
        }
      });
  }

  private async GetDoctorReportsData(
    consultation_id: number,
    patientGuid: string
  ) {
    await this.doctorsService
      .GetDoctorReportspdf(patientGuid, consultation_id, 'report')
      .toPromise()
      .then((result) => {
        this.doctorReportsApiResult.PromiseResult = result;
        if (result.success) {
          this.response = result;
          this.doctorReportsData = result.data;
        }
      });
  }

  async CloseDialog(): Promise<void> {
    this.displayModel = false;
    this.displayModel1 = false;
  }

  print() {
    window.print();
  }
  showDialog(user: any) {
    this.display = true;
    this.consent_update.has_consented = user.has_consented;
    this.consent_update.req_id = user.req_id;
  }
  async updateConsent() {

    await this.supportservice
      .UpdateConsent(this.consent_update)
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.update_msg = "Consent Updated successfully";
          this.getVendorPatientList(null);
          this.display = false;
        }
        this.update_msg = '';
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
